import 'isomorphic-fetch';

////////////////
//////////////////////////
////////////////////////
///////////////////////////////
/////////////////////////////////////////////////////////////
////////
///////////////////////////////
////////////////////
//////////////////
////////////////////////
////////////////////////////
////////////////
////////////////////
/////////////////
/////////////////////////
/////////////////////////
////////////////////////
////////////////////////

/////////////////////////////////////////////
////////////////////
///////////////////////////////
//////////////////
////////////////////////
///////////
///////////
////////////////////
///////////////
///////////////////
///////////////////////
///////////////
////////////////////
//

/////////////////////////////////
////////////////////////////
////////////////
////////////////////
/////////////////
/////////////////////////
/////////////////////////
///

///////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////
//////////////////
/////////////////
///
////////////////////////////////////
//////////////////
/////////////////
///

//////////

/**
 * Isomorphic fetch wrapper
 * */
export default async (input: RequestInfo, init?: RequestInit): Promise<Response> => {
  // Apply defaults
  init = {
    // Older browsers with fetch support initially defaulted to `omit` instead of the specification default `same-origin`, so explicitly set it.
    // https://developer.mozilla.org/en-US/docs/Web/API/Request/credentials#browser_compatibility
    credentials: 'same-origin',
    ...(init ?? {}),
  };

//////////////////
///////////////////////////

////////////
///////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////

/////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
/////////////////
///////////////////////////////////
//////////////////////////////////////
/////////////////////////
////////////////////////////////////////
////////
/////////////////

////////////////////
//////////////////////
///////////////////////////////////
//////
////////////////////////////
//////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
//////
///
////////////
  const remoteResponse = await fetch(input, init);

//////////////////
////////////
////////////////////////////////////////////////////////////////////
//////////////////////////////////////
////
////////////
  return remoteResponse;
};
